import script from "./HelpTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpTooltip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__